var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9584 2.04175H12.4584V1.54175H11.9584V2.04175ZM11.9584 11.9584V12.4584H12.4584V11.9584H11.9584ZM2.04175 11.9584H1.54175V12.4584H2.04175V11.9584ZM2.04175 2.04175V1.54175H1.54175V2.04175H2.04175ZM11.9584 6.04175H12.4584V5.04175H11.9584V6.04175ZM2.04175 5.04175H1.54175V6.04175H2.04175V5.04175ZM11.4584 2.04175V11.9584H12.4584V2.04175H11.4584ZM11.9584 11.4584H2.04175V12.4584H11.9584V11.4584ZM2.54175 11.9584V2.04175H1.54175V11.9584H2.54175ZM2.04175 2.54175H11.9584V1.54175H2.04175V2.54175ZM2.04175 6.04175H11.9584V5.04175H2.04175V6.04175Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.38a9c65c2ff97062395f46439cbfb6ad.svg";
export { ForwardRef as ReactComponent };